import { useEffect, useState } from "react";
import {
  applyAuthResponse,
  fetchAdminAuthControllerRefresh,
  Tokens,
  useAuthStore,
} from "service";

export interface UseSetup {
  isReady: boolean;
}

const useSetup = (): UseSetup => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const { role, setIsLoggedIn } = useAuthStore();

  useEffect(() => {
    const initialize = async () => {
      const tokens = Tokens.retrieveFromLocalStorage();
      try {
        if (tokens && role) {
          setIsLoggedIn(true);
        } else if (tokens && !role) {
          // Tokens (localStorage key "authToken") survived independently of
          // the zustand-persisted auth-store session ("auth-storage"). This is
          // the normal shape for every session that predates multi-tenancy -
          // it does NOT mean the session is corrupted, so don't force a
          // logout. Reconcile once via a forced refresh (piped through the
          // same applyAuthResponse used by login) to backfill role/org onto
          // the store. Only log out if the refresh itself fails, which means
          // the refresh token is genuinely invalid.
          try {
            const response = await fetchAdminAuthControllerRefresh({
              body: { refreshToken: tokens.refreshToken },
            });

            if (response.data?.accessToken && response.data?.refreshToken) {
              applyAuthResponse(response.data);
            } else {
              Tokens.destroy();
              setIsLoggedIn(false);
            }
          } catch (error) {
            console.error("Session reconciliation failed:", error);
            Tokens.destroy();
            setIsLoggedIn(false);
          }
        }
      } finally {
        setIsReady(true);
      }
    };

    initialize();
  }, []);

  return {
    isReady,
  };
};

export default useSetup;
